import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BcService } from 'src/app/shared/services/bc/bc.service';
import { BpService } from 'src/app/shared/services/bp/bp.service';
import { NTHFlag } from 'src/app/shared/constants/flag';
import { GlobalSettingsService } from 'src/app/core/gobal-settings.service';
import { environment } from 'src/environments/environment';

export interface DialogData {
  icone: string;
  title: string;
  message: string;
  color: string;
  icon_color: string;
  dialogWidth: string;
  dialogHeight: string;
  type: string;
  statut: string;
  result: boolean;
  codeCa1: string;
  idSociete: number;
  nivStatus: number;
  fAnnule: NTHFlag;
  fDeprovis: NTHFlag;
  fLivre: NTHFlag;
  fHasBp: NTHFlag;
  listBp: boolean;
  bBloquer: boolean;
}

@Component({
  selector: 'app-modal-annulation-confirmation',
  templateUrl: './modal-annulation-confirmation.component.html',
  styleUrls: ['./modal-annulation-confirmation.component.scss']
})
export class ModalAnnulationConfirmationComponent implements OnInit {
    icone: string;
    title: string;
    message: string;
    color: string;
    iconColor: string;
    dialogWidth: string;
    dialogHeight: string;
    ValidationStatus: string[] = ['A Valider', 'Validation 1', 'Validation 2', 'Validation 3', 'Validation 4'];
  
    currentRoute: any;
    bpDisplayState: any;
    environment: boolean = environment.BP_ACTIF;
    constructor(public dialog: MatDialog,
                private toastr: ToastrService,
                public router: Router,
                private bcService: BcService,
                private bpService: BpService,
                public dialogRef: MatDialogRef<Component>,
                @Inject(MAT_DIALOG_DATA) public data: DialogData,
                private globalSettingsService: GlobalSettingsService) {
    }
  
    ngOnInit(): void {
      this.currentRoute = this.router.url;
      this.icone = this.data.icone !== undefined ? this.data.icone : '';
      this.title = this.data.title !== undefined ? this.data.title : '';
      this.iconColor = this.data.icon_color !== undefined ? this.data.icon_color : '';
      this.dialogWidth = this.data.dialogWidth !== undefined ? this.data.dialogWidth : '';
      this.dialogHeight = this.data.dialogHeight !== undefined ? this.data.dialogHeight : '';
      this.message = this.data.message;
      this.color = this.data.color;
    }
  
    onModalCancel(): void {
      this.dialogRef.close(false);
    }
  
    onModalConfirm(): void {
      this.data.result = true;
      this.dialogRef.close(true);
    }
  
  }
  
